import { defineStore } from "pinia";
import getAPLinkInfo, {
  network,
  getScatter,
  initLink,
  scope,
  onAppRemoveSession,
  getClient,
  verifyProof,
} from "@/utils/client";
import { StorageHelper } from "@/utils/storage";
import _service from "@/service";
import { Client, ServerEventType, type Account } from "@amax/amaxup";
import service from "@/service/service";
import { bySplit } from "@/utils";
import { getArmadillo } from "@/utils/armadillo";
import { showToast } from "vant";
export type AccountStatus = 0 | 1; // 0: 未激活   1：已激活
export interface AcountState {
  kyc: boolean;
  name: string;
  publicKey: string;
  status: AccountStatus;
}
export async function login_scatter() {
  const accountStore = useAccountStore()
  try {
    let publicKey = ''
    const scatter: any = getScatter();
    const identity = await scatter.getIdentity({
      accounts: [{ chainId: network.chainId, blockchain: network.blockchain }],
    });
    const account = identity?.accounts[0];
    StorageHelper.setItem('walletAddress', account.name);
    StorageHelper.setItem('authority', account.authority);
    const accountData: any = await _service.getPubkeyByAccount(
      account.name
    );
    console.log(accountData, "accountData");
    publicKey = accountData.permissions[0]?.required_auth.keys[0]?.key;
    accountStore.setUserInfo({
        kyc: identity.kyc,
        name: account.name,
        publicKey: publicKey,
        status: 1
    })
    return {identity,account};

  } catch (e) {
    console.error("login Error:", e);
  }
}

export async function login_anchor() {
  const accountStore = useAccountStore()
  const link = initLink();
  let accountStatus: AccountStatus;
  let publicKey = "";
  const identity = await link.login(scope);
  const {proof} = await verifyProof(
      link,
      identity,
  );
  await onAppRemoveSession();
  const walletAddress = proof.signer.actor.toString();
  const authority = proof.signer.permission.toString();
  const chainId = network.chainId;
  
  console.log(authority,'authority');
  StorageHelper.setItem('authority', authority);
  StorageHelper.setItem('walletAddress', walletAddress);
  StorageHelper.setItem('chainId', chainId);
  sessionStorage['link']= 'yes'
  try {
    const accountData: any = await _service.getPubkeyByAccount(
      walletAddress
    );
    console.log(accountData, "accountData");
    publicKey = accountData.permissions[0].required_auth.keys[0].key;
    accountStatus = 1;
  } catch (e) {
    console.log(e, "e");
    publicKey = "";
    accountStatus = 0;
  }
  accountStore.setUserInfo({
    kyc: identity.kyc,
    name: walletAddress,
    publicKey: publicKey,
    status: accountStatus,
  });
}

export async function login_armadillo() {
  console.log('login_armadillo');
  const accountStore = useAccountStore()
  if (sessionStorage.getItem('startnest_userInfo')) {
    const _data = JSON.parse(sessionStorage.getItem('startnest_userInfo') || '')
    accountStore.setUserInfo(_data)
    return
  }
  const armadillo = getArmadillo()
  console.log(armadillo,'armadillo');
  const accounts = await armadillo.requestAccounts();
  console.log(accounts,'accounts');
  if (accounts.length) {
    const { account, publicKey } = accounts[0];
    StorageHelper.setItem("walletAddress", account);
    StorageHelper.setItem("authority", "active");
    const startnest_userInfo:AcountState = {
      kyc: false,
      name: account,
      publicKey: publicKey,
      status: 1,
    }
    accountStore.setUserInfo(startnest_userInfo);
    sessionStorage.setItem('startnest_userInfo',JSON.stringify(startnest_userInfo))
    console.log(accountStore,'accountStore');
  } else {
    showToast('no account')
  }
}

export async function login_amaxup() {
  const accountStore = useAccountStore()
  const client = new Client();
  client.on(ServerEventType.ACCOUNTS_CHANGED, (accounts: Account[]) => {
    // ...
      console.log(accounts,'accounts');
      if (accounts.length) {
          const {name,publicKey} = accounts[0]
          localStorage.setItem('walletAddress', name);
          localStorage.setItem('authority','active');
          accountStore.setUserInfo({
            kyc: false,
            name: name,
            publicKey: publicKey,
            status: 1,
          });
      }
  })
  const account = await client.getAccount();
  console.log(account, "account");
  localStorage.setItem("walletAddress", account.name);
  localStorage.setItem("authority", account.permission);
  accountStore.setUserInfo({
    kyc: false,
    name: account.name,
    publicKey: account.publicKey,
    status: 1,
  });
}


export const useAccountStore = defineStore("account", {
  state: () => ({
    account: {
      kyc: false,
      name: "",
      publicKey: "",
      status: 1,
    },
    tokenList: <any>[],
    taskData:<any>{},
    globalData:<any>{}
  }),
  getters: {
    async connectWallet() {
      console.log(488);
      
      try {
        // const client = new Client();
        //   //判断amaxup环境
        // if (client.isInIframe()) {
        //   console.log(`登陆环境:amaxup`);
        //   await login_amaxup()
        //   return false;
        // } else {
         
        // }
         // 判断armadillo环境
         if ((window as any).armadillo) {
          console.log(`登陆环境:armadillo`);
          (window as any).armadillo. on('accountsChanged',async(accounts:any[])=>{
            sessionStorage.removeItem('startnest_userInfo')
            console.log('accountsChanged');
            if (accounts.length){
              await login_armadillo();
            }else {
              console.error('账号未激活');
            }
          })
          await login_armadillo()
        } 
      } catch (e) {
        console.error("login Error:", e);
      }
    },
    getUserInfo(state) {
      return state.account;
    },
    getTokenListByAccount(state) {
      return state.tokenList;
    },
    getTaskFinished(state) {
      return state.taskData
    }
    
  },
  actions: {
    // 任何数量的参数，返回一个 Promise 或者不返回
    setUserInfo(data: AcountState) {
      this.account = data;
      // this.getTokensByAccount()
    },
    async getBalanceByUser(symbol: string) {
      try {
        const res = this.getTokenListByAccount;
        let code = res.filter((item: any) => {
          return item.coin === symbol;
        })[0].code;
        const data: any = await _service.getBalanceByUser({
          code,
          account: this.account.name,
          symbol,
        });
        return data.length ? data[0].split(" ")[0] : 0;
      } catch (error) {
        return "";
      }
    },
    async getTokensByAccount() {
      console.log("getTokens---");
      const res = await _service.getTokenListByAccount(this.account.name);
      const _tokens = await _service.getTokenList({
        pageNum: 0,
        pageSize: 100,
        search: "",
      });
      const _arr: any = [];
      _tokens.data.map((token: any) => {
        const balance = res.data.filter((item: any) => {
          return item.coin === token.coin;
        })[0]?.balance;
        _arr.push({
          ...token,
          balance: balance || (0).toFixed(token.precision),
        });
      });
      this.tokenList = _arr;
    }
  },
});
